export default __webpack_public_path__ + "static/pocketHump-3f9ef9657444c946c5bc92b11f72e813.png";